import { ListItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { DRAWER_WIDTH } from "@constants/layout.style.ts";

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  paddingBottom: theme.spacing(3),
  ...theme.mixins.toolbar,
}));

export const DrawerStyled = styled(
  SwipeableDrawer,
  {},
)<{ open: boolean }>(({ theme }) => ({
  "position": "fixed",
  "zIndex": 2000,
  "backgroundColor": "#ffffff",
  "color": theme.palette.common.white,
  "overflowX": "hidden",
  "whiteSpace": "nowrap",
  "boxSizing": "border-box",
  "width": DRAWER_WIDTH,

  "& .MuiPaper-root": {
    width: DRAWER_WIDTH,
    padding: theme.spacing(3),
  },
}));

export const NavItemContainerStyled = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(0.5),
}));

export const NavItemDividerStyled = styled("div")(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.strokeColor.secondary}`,
}));

export const SidebarListItemButtonStyled = styled(ListItem)(({ theme }) => ({
  "display": "block",
  "padding": theme.spacing(1.75),
  "cursor": "pointer",
  "minHeight": "48px",
  "color": theme.palette.text.primary,

  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    borderRadius: theme.spacing(0.5),
  },

  "&.MuiListItem-root *": {
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

export const SidebarListItemButtonNestedStyled = styled(SidebarListItemButtonStyled)(
  ({ theme }) => ({
    paddingLeft: theme.spacing(4),
    border: "none",
  }),
);
